import AgencyInfo from 'client/common/components/agency-info';

import './index.css';

export default AgencyInfo;
